import {
    computed,
    defineComponent,
    inject,
    onMounted,
    onServerPrefetch,
    reactive,
    ref,
    toRefs
} from 'vue';
import {useContext} from "@/Ph";
import {useRoute} from "vue-router";
import {categoryController} from "@shared-core/service/CategoryController";
import CategoryDefaultDto from "@shared-core/service/model/category/CategoryDefaultDto";
import {getLimitStringByWord, getProductDetailUrl, getUnitString, setSeo, setCanonicalUrl} from "@/utils/displayUtil";
import {getPhotoUrl} from "@/Directive";
import Crumb from "@/components/crumb/Crumb.vue";
import HeaderDto from "@shared-core/service/model/header/HeaderDto";

export default defineComponent({
    components: {Crumb},
    setup() {
        const context = useContext();
        const route = useRoute();
        let headInfo = <HeaderDto>inject('headInfo');

        const state = reactive({
            categoryDefault: <CategoryDefaultDto>{},
        });

        const getCategoryImageUrl = (imageUrl: string) => {
            return "https://www.beadpark.com/categoryPhotos/" + imageUrl;
        };

        onServerPrefetch(async () => {
            const categoryId = Number(route.params.categoryId);
            state.categoryDefault = await categoryController.categoryDefault(categoryId);
            context.clientData['categoryDefault'] = state.categoryDefault;

            const seo = state.categoryDefault.seo;
            if (seo) {
                setSeo(seo.title, seo.keywords, seo.description);
            }
            // 添加 canonical 标签（服务端渲染）
            setCanonicalUrl(route, context);
        });
        if(context.isClient) {
            state.categoryDefault = context.clientData['categoryDefault'];
        }
        // 客户端挂载时再做事件绑定
        onMounted(() => {
            if (state.categoryDefault?.seo) {
                setSeo(
                    state.categoryDefault.seo.title,
                    state.categoryDefault.seo.keywords,
                    state.categoryDefault.seo.description
                );
            }
            // 添加 canonical 标签（客户端）
            setCanonicalUrl(route, context);
        });

        return {
            ...toRefs(state),
            getLimitStringByWord,
            getProductDetailUrl,
            getUnitString,
            getPhotoUrl,
            getCategoryImageUrl
        };
    }
});
